export function getdata() {
	let obj = {
		formdata: {
			currency: "",
			currencyDesc: ""
		},
		formlist: [{
				prop: "currency",
				label: "币种",
				type: "input",
				isnotnull: true,
			},
			{
				prop: "currencyDesc",
				label: "币种中文描述",
				type: "input",
				isnotnull: true,
		
			}
		],
		headData: [{
				title: "币种",
				prop: "currency",
				width: "100"
			},
			{
				title: "币种中文描述",
				prop: "currencyDesc",
				width: "100"
			},
			{
				title: "是否本位币",
				prop: "standardCurrency",
				width: "100",
				custom: true
			}
			
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
	}
	return obj
}
